import { orderService } from '../../services/OrderService'
import Loading from 'vue-loading-overlay';
import SearchBox from '../../views/Controls/SearchBox';

export default {
    name: 'OrderTypes',
    components: {
        Loading,
        SearchBox
    },
    props: {
    },
    data: () => {
        return {
            loading: true,
            currentPage: 1,
            perPage: 10,
            orderTypes: [],
            focusedRowObject: null,
            selectedRowClass: 'secondary',
            fields: [],
            searchFilter: '',
            itemToBeDeleted: null,
            totalRows: 0,
        }
    },
    // Fetches posts when the component is created.
    created() {
        var model = this;
        model.fields = [
            { key: 'Description', label: 'Descriere', sortable: true, thStyle: 'width:70%' },
            { key: 'IsActive', label: 'Activ', sortable: true, thStyle: 'width:20%' },
            { key: 'Id', label: 'Id', thStyle: 'width:10%' }
        ];

        var orderTypePromise = orderService.getOrderTypes()
            .then(response => {
                model.orderTypes = response.data;
            })
            .catch(e => {
                showErrorNotification(e);
            });

        axios.all([orderTypePromise])
            .then(axios.spread(function () {
                model.loading = false;
            }));
    },
    methods: {
        searchTextChanged: function (searchText) {
            this.searchFilter = searchText;
        },
        addButtonClick() {
            this.$router.push({ name: 'OrderType', params: { id: 0 } })
        },
        editButtonClick(data) {
            if (data != null) {
                this.$router.push({ name: 'OrderType', params: { id: data.item.Id } });
            }
        },
        setItemToBeDeleted(data) {
            if (data != null) {
                this.itemToBeDeleted = data.item;
            }
        },
        deleteButtonClick(dataItem) {
            if (dataItem != null) {
                var model = this;

                var orderTypePromise = orderService.deleteOrderType(dataItem.Id, dataItem.RowVersion)
                    .then(response => {
                        model.removeItem(model.orderTypes, dataItem.Id);
                    })

                axios.all([orderTypePromise])
                    .then(axios.spread(function () {
                        model.loading = false;
                    }));
            }
        },
        //
        getIsActiveBadge(isActive) {
            return isActive === true ? 'success' : 'secondary'; //class
        },
        getIsActiveText(isActive) {
            return isActive === true ? 'Activ' : 'Inactiv';
        },
    }
}
